export default "__VITE_ASSET__DkN8IlGS__"